import { render, staticRenderFns } from "./McpAuthorize.vue?vue&type=template&id=967fab0a&scoped=true&"
import script from "./McpAuthorize.vue?vue&type=script&lang=js&"
export * from "./McpAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./McpAuthorize.vue?vue&type=style&index=0&id=967fab0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967fab0a",
  null
  
)

export default component.exports